import gql from 'graphql-tag';

export default gql`
  query ($subject: MongoID, $student: MongoID) {
    studentofsubjects(filter: { subject: $subject, student: $student }, limit: 10000) {
      _id
      subject {
        _id
        name
      }
      student {
        _id
        firstname
        lastname
      }
      certificatestatus
      creditstatus
      payment_image
      answers
    }
  }
`;
